import { gql } from "@apollo/client";


export const CREATE_SESSION = gql`
mutation createSession(
  $cId: UUID!, 
  $startDate: Datetime!, 
  $endDate: Datetime!, 
  $topic: String!, 
  $sjId: UUID!, 
  $discussionPeriod: String!, 
  $teachingPeriod: String!,
  $description:String!, 
  $pMeetingType: MeetingType) {
  addSessionToLiveclass(
    input: {
      pClassroomId: $cId, 
      pEndDate: $endDate, 
      pLessonTopic: $topic, 
      pStartDate: $startDate, 
      pSubjectId: $sjId, 
      pDiscussionPeriod: $discussionPeriod, 
      pTeachingPeriod: $teachingPeriod, 
      pDescription: $description, 
      pMeetingType: $pMeetingType
    }
  ) {
    clientMutationId
  }
}
`

export const GET_ALL_LIVE_SESSIONS = gql`
query getLiveSessions($cId: UUID!, $sjId: UUID!, $startDate: Datetime!, $limit: Int = null, $offset: Int = null) {
  getLiveClassSessions(
    classroomId: $cId
    subjectId: $sjId
    first: $limit
    offset: $offset
    filter: {and: [{isSessionEnd: {equalTo: false}}, {or: [{startDate: {greaterThanOrEqualTo: $startDate}}, {endDate: {greaterThanOrEqualTo: $startDate}}]}]}
    currentDatetime: $startDate
  ) {
    nodes {
      sessionId
      startDate
      endDate
      savedSessionUrl
      lessonTopic
      isactive
      isSessionStart
      isSessionEnd
    }
    totalCount
  }
}
`;

export const GET_SESSTION_BY_ID=gql`
query getSession($input: getSessionInput!) {
  getSession(input: $input) {
    sessionId
    startdate
    enddate
    isActive
    isSessionStart
    lessonTopic
    sessionCode
    teachingPeriod
    description
    participantscount
    hostId
    isRecordStart
    recordStartTime
    serverUrl
    botUrl
    meetingType
    participantIds
    discussionPeriod
    replicaMeetingIds
    showChat
    originalHostId
    mediaPipelineId
    mediaPipelineArn
  }
}
`;

export const IS_LIVE_SESSION_NOW = gql`
query checkSessionExists($cId: UUID!,$currentDateTime:Datetime!) {
  isLiveSessionOngoing(classroomId: $cId, currentDatetime:$currentDateTime )
}
`;

export const GET_ALL_SAVED_SESSIONS = gql`
query getLiveSavedSession($limit: Int = null, $offset: Int = null, $cId: UUID!, $sjId: UUID!) {
  allRecordedSessions(
    filter: {deletedAt: {isNull: true}, recordSessionType: {equalTo: LIVE}, cId: {equalTo: $cId}, sjId: {equalTo: $sjId}}
    first: $limit
    offset: $offset
    orderBy: CREATED_AT_DESC
  ) {
    nodes {
      rsId
      savedSessionUrl
      recordSessionType
      createdAt
      sjId
      sessionId
      topic
      videosPlaybacktimesByRsId {
        nodes {
          playbackTime
        }
      }
    }
    totalCount
  }
}
`;

export const UPDATE_SCHEDULED_SESSION = gql`
mutation updateSession(
  $cId: UUID!, 
  $endDate: Datetime!, 
  $startDate: Datetime!, 
  $topic: String!, 
  $sId: UUID!, 
  $sjId: UUID!, 
  $discussionPeriod: String!, 
  $teachingPeriod: String!,
  $description:String!, 
  $pMeetingType: MeetingType
) {
  updateSessionInLiveclass(
    input: {
      pCId: $cId, 
      pEnddate: $endDate, 
      pLessonTopic: $topic, 
      pSessionId: $sId, 
      pStartdate: $startDate,
      pSubjectId: $sjId, 
      pDiscussionPeriod: $discussionPeriod, 
      pTeachingPeriod: $teachingPeriod, 
      pDescription: $description, 
      pMeetingType: $pMeetingType
    }
  ) {
    clientMutationId
  }
}
`

export const  DELETE_SCHEDULED_SESSION = gql`
mutation deleteSession($cId: UUID!, $sId: UUID!, $sjId: UUID!, $pMeetingType: MeetingType) {
  deleteSessionInLiveclass(input: {pCId: $cId, pSessionId: $sId, pSubjectId: $sjId, pMeetingType: $pMeetingType}) {
    clientMutationId
  }
}
`;

export const UPDATE_SESSION_STATUS = gql`
mutation updateSessionStatus($cId: UUID!, $sId: UUID!, $sjId: UUID!,$sCode:String!, $hostId: String) {
  updateSessionStart(
    input: {pCId: $cId, pSessionId: $sId, pSubjectId: $sjId, pSessionCode: $sCode, hostId: $hostId}
  ) {
    clientMutationId
  }
}
`;

export const UPDATE_SESSION_PARTICIPANTS_COUNT = gql`
mutation UpdateSessionParticipantsCount(
  $cId: UUID!
  $sId: UUID!
  $sjId: UUID!
  $participantCount: Int!
) {
  updateSessionParticipants(
    input: {
      pCId: $cId
      pSessionId: $sId
      pSubjectId: $sjId
      pParticipantCount: $participantCount
    }
  ) {
    clientMutationId
  }
}
`;

export const UPDATE_PLAY_TIME_FOR_VIDEO  = gql`
mutation updateSessionPlaybackTime($cId:UUID!,$sePlayBackTime:String!,$sId:UUID!,$sjId:UUID!) {
  updateSessionPlaybackTime(
    input: {pCId: $cId, pSessionPlaybackTime: $sePlayBackTime, pSessionId: $sId, pSubjectId: $sjId}
  ) {
    clientMutationId
  }
}
`;

export const END_THE_LIVE_SESSION = gql`
mutation updateSessionEndStatus($cId: UUID!, $sId: UUID!, $sjId: UUID!) {
  editSessionEnd(input: {pCId: $cId, pSessionId: $sId, pSubjectId: $sjId}) {
    clientMutationId
  }
}`;

export const CREATE_MEDIASERVER_ERROR_LOG = gql`
mutation createMediaSeverErrorLog($input: CreateMediaserverErrorLogInput!) {
  createMediaserverErrorLog(input: $input) {
    mediaserverErrorLog {
      id
    }
  }
}
`;

export const GET_ERROR_DATA_BY_ID = gql`
query getAllMediaserverErrorLog($id: UUID!) {
   allMediaserverErrorLogs(filter: {id: {equalTo: $id}}) {
     nodes {
      createdAt
      deletedAt
     errorDescription
       errorInfo
       id
      errorType
      meetId
      nodeId
      retryCount
      status
      updatedAt
     userId
    }
   }
 }
`;

export const UPDATE_ERROR_DATA = gql`
mutation updateMediaServerErrorLogById($input: UpdateMediaserverErrorLogByIdInput!){
  updateMediaserverErrorLogById(input: $input) {
    clientMutationId
  }
}
`;

export const GET_USER_BY_ID = gql`
  query getUserById($uId: UUID!) {
    userByUId(uId: $uId) {
      uFullName
    }
  }
`;
